export default __webpack_public_path__ + "static/media/downloadPDF.17db872d.svg";